import { render, staticRenderFns } from "./breakdowns.vue?vue&type=template&id=7ab1e11e&"
import script from "./breakdowns.vue?vue&type=script&lang=js&"
export * from "./breakdowns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports